import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange, onClearFilters }) => {
  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'new', label: 'Nouveau' },
    { value: 'reviewed', label: 'En revue' },
    { value: 'scheduled', label: 'Programmé' },
    { value: 'completed', label: 'Terminé' },
    { value: 'cancelled', label: 'Annulé' }
  ];

  const urgencyOptions = [
    { value: 'all', label: 'Toutes les urgences' },
    { value: 'routine', label: 'Routine' },
    { value: 'urgent', label: 'Urgent' },
    { value: 'emergency', label: 'Urgence' }
  ];

  const hasActiveFilters = 
    filters?.status !== 'all' ||
    filters?.urgency !== 'all' ||
    filters?.referringDentist ||
    filters?.dateFrom ||
    filters?.dateTo ||
    filters?.searchTerm;

  return (
    <div className="bg-card-elevated border border-white/8 p-6 rounded-xl mb-8 shadow-lg">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Icon name="Filter" size={20} className="text-accent" />
          <h2 className="text-lg font-semibold text-primary">Filtres</h2>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
          >
            Réinitialiser
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Search */}
        <div className="lg:col-span-3">
          <Input
            placeholder="Rechercher par patient, dentiste ou numéro de dent..."
            value={filters?.searchTerm}
            onChange={(e) => onFilterChange({ searchTerm: e?.target?.value })}
          />
        </div>

        {/* Status Filter */}
        <Select
          label="Statut"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange({ status: value })}
        />

        {/* Urgency Filter */}
        <Select
          label="Urgence"
          options={urgencyOptions}
          value={filters?.urgency}
          onChange={(value) => onFilterChange({ urgency: value })}
        />

        {/* Referring Dentist */}
        <Input
          label="Dentiste adresseur"
          placeholder="Nom du dentiste"
          value={filters?.referringDentist}
          onChange={(e) => onFilterChange({ referringDentist: e?.target?.value })}
        />

        {/* Date From */}
        <Input
          label="Date de début"
          type="date"
          value={filters?.dateFrom}
          onChange={(e) => onFilterChange({ dateFrom: e?.target?.value })}
        />

        {/* Date To */}
        <Input
          label="Date de fin"
          type="date"
          value={filters?.dateTo}
          onChange={(e) => onFilterChange({ dateTo: e?.target?.value })}
        />
      </div>
    </div>
  );
};

export default FilterPanel;